import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Moment from 'moment';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, change as _change } from 'redux-form';
import Swal from 'sweetalert2';
import { deleteAbsence as _deleteAbsence, clearSubmitResult as _clearSubmitResult } from 'actions/absence';
import { addError as _addError } from 'actions';
import DatePicker from 'components/Inputs/DatePicker';
import TimePicker from 'components/Inputs/TimePicker';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import { Button, Spinner } from '@haldor/ui';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { translate, getActiveLanguage } from '@haldor/ui';
var ReportAbsenceForm = /*#__PURE__*/function (_Component) {
  function ReportAbsenceForm(props) {
    var _this;
    _classCallCheck(this, ReportAbsenceForm);
    _this = _callSuper(this, ReportAbsenceForm, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      // Clear any prior submit errors when the form mounts/rerenders
      if (_this.props.clearSubmitResult) _this.props.clearSubmitResult();
      if (_this.props.user != null) {
        _this.setState({
          loading: true
        });
      }
      if (_this.props.absence != null) {
        _this.selectAbsence(_this.props.absence);
      }

      // Default to entire day for new reports
      if (_this.props.absence == null && (_this.props.entireDay === undefined || _this.props.entireDay === null)) {
        _this.props.change(FORM_NAME, 'entireDay', 'yes');
      }
    });
    _defineProperty(_this, "onTimeChange", function (time) {
      var start = Moment(time.start);
      var end = Moment(time.end);

      // If user picked a start after the current end, move end to start
      if (start.isAfter(end)) {
        end = start.clone();
      }
      if (_this.props.entireDay == 'yes') {
        _this.setState({
          timeStart: start.set({
            'minute': 0,
            'hour': 0
          }).format(),
          timeEnd: end.set({
            'minute': 59,
            'hour': 23
          }).format()
        });
        var diffMinutes = end.clone().set({
          'minute': 59,
          'hour': 23
        }).diff(start.clone().set({
          'minute': 0,
          'hour': 0
        }), 'minutes');
        var datesInvalid = diffMinutes <= 0;
        _this.setState({
          datesInvalid: datesInvalid
        });
      } else {
        _this.setState({
          timeStart: start.format(),
          timeEnd: end.set({
            'minute': time.end.minute(),
            'hour': time.end.hour()
          }).format()
        });
        if (_this.props.entireDay == 'no') {
          var _diffMinutes = end.clone().set({
            'minute': time.end.minute(),
            'hour': time.end.hour()
          }).diff(start, 'minutes');
          var _datesInvalid = _diffMinutes <= 0;
          _this.setState({
            datesInvalid: _datesInvalid
          });
        }
      }
    });
    _defineProperty(_this, "onEntireDay", function () {
      var start = Moment(_this.state.timeStart);
      var end = Moment(_this.state.timeEnd);
      start = start.set(_defineProperty(_defineProperty({
        'minute': 0,
        'hour': 0
      }, "minute", 0), 'second', 0));
      end = end.set(_defineProperty(_defineProperty({
        'minute': 59,
        'hour': 23
      }, "minute", 59), 'second', 0));
      _this.setState({
        datesInvalid: false
      });
      _this.onTimeChange({
        start: start,
        end: end
      });
    });
    _defineProperty(_this, "onPartOfDay", function () {
      _this.setState({
        datesInvalid: false
      });
    });
    _defineProperty(_this, "renderEntireDayRadio", function (_ref) {
      var input = _ref.input,
        meta = _ref.meta,
        disabled = _ref.disabled;
      var currentValue = input && input.value !== undefined ? input.value : '';
      var handleChange = function handleChange(event) {
        var value = event.target.value;
        if (input && input.onChange) input.onChange(value);
        if (value === 'yes') _this.onEntireDay();
        if (value === 'no') _this.onPartOfDay();
      };
      return /*#__PURE__*/React.createElement(FormControl, {
        component: "fieldset",
        disabled: disabled
      }, /*#__PURE__*/React.createElement(RadioGroup, {
        name: input.name,
        value: currentValue,
        onChange: handleChange,
        row: true
      }, /*#__PURE__*/React.createElement(FormControlLabel, {
        value: "yes",
        control: /*#__PURE__*/React.createElement(Radio, null),
        label: _this.props.translate('Entire day')
      }), /*#__PURE__*/React.createElement(FormControlLabel, {
        value: "no",
        control: /*#__PURE__*/React.createElement(Radio, null),
        label: _this.props.translate('Part of day')
      })));
    });
    _defineProperty(_this, "selectAbsence", function (absence) {
      _this.setState({
        id: absence.id,
        timeStart: Moment.utc(absence.startTime).local().format(),
        timeEnd: Moment.utc(absence.endTime).local().format()
      });
      var startTime = Moment.utc(absence.startTime).local();
      var endTime = Moment.utc(absence.endTime).local();
      var isStartOfDay = startTime.isSame(startTime.clone().startOf('day'), 'minute');
      var isEndOfDay = endTime.isSame(endTime.clone().endOf('day'), 'minute');
      var isEntireDay = isStartOfDay && isEndOfDay;
      _this.props.change('ReportAbsence', 'entireDay', isEntireDay ? 'yes' : 'no');
      _this.setState({
        loading: false
      });
    });
    _defineProperty(_this, "submit", function (values) {
      // Build API payload with required shape
      var startIso = Moment(_this.state.timeStart).utc().seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss[Z]');
      var endIso = Moment(_this.state.timeEnd).utc().seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss[Z]');
      var data = {
        entireDay: _this.props.entireDay,
        startTime: startIso,
        endTime: endIso,
        // period: true means an all-day / multi-day absence. For part-of-day set period=false
        period: _this.props.entireDay === 'yes',
        userId: _this.props.user
      };
      if (_this.state.id != null) data.id = _this.state.id;
      return _this.props.onSubmit(data);
    });
    _defineProperty(_this, "onDelete", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var translate, result, deletePromise, msg, _t, _t2;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Prevent form submission and event bubbling
              if (e) {
                e.preventDefault();
                e.stopPropagation();
              }
              translate = _this.props.translate;
              _context.prev = 1;
              _context.next = 2;
              return Swal.fire({
                title: translate('Remove absence?'),
                text: translate('You are about to permanently delete this absence.'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: translate('Yes, remove it!'),
                cancelButtonText: translate('Cancel'),
                allowOutsideClick: false,
                allowEscapeKey: false
              });
            case 2:
              result = _context.sent;
              if (!(result.isConfirmed || result.value === true)) {
                _context.next = 8;
                break;
              }
              _this.setState({
                deleting: true
              });
              if (!_this.props.deleteAbsence) {
                _context.next = 7;
                break;
              }
              _context.prev = 3;
              deletePromise = _this.props.deleteAbsence(_this.state.id);
              if (!(deletePromise && typeof deletePromise.then === 'function')) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return deletePromise;
            case 4:
              if (_this.props.onAbort) {
                _this.props.onAbort();
              }
              _context.next = 6;
              break;
            case 5:
              _context.prev = 5;
              _t = _context["catch"](3);
              console.error('Delete API error:', _t);
              msg = _t && _t.message ? _t.message : translate('Error deleting absence');
              if (_this.props.addError) {
                _this.props.addError(msg);
              }
              _this.setState({
                deleting: false
              });
            case 6:
              _context.next = 8;
              break;
            case 7:
              console.error('deleteAbsence prop not found');
              _this.setState({
                deleting: false
              });
            case 8:
              _context.next = 10;
              break;
            case 9:
              _context.prev = 9;
              _t2 = _context["catch"](1);
              console.error('Swal error:', _t2);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 9], [3, 5]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    Moment.locale(getActiveLanguage());
    _this.state = {
      id: null,
      loading: true,
      timeStart: Moment(),
      timeEnd: Moment(),
      datesInvalid: false,
      entireDay: null,
      deleting: false
    };
    return _this;
  }
  _inherits(ReportAbsenceForm, _Component);
  return _createClass(ReportAbsenceForm, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      if (prevProps.entireDay !== this.props.entireDay) {
        if (this.props.entireDay === 'yes') {
          this.onEntireDay();
        } else if (this.props.entireDay === 'no') {
          this.onPartOfDay();
        }
      }
      if (prevProps.absence !== this.props.absence) {
        if (this.props.absence != null) {
          this.selectAbsence(this.props.absence);
        } else {
          this.setState({
            id: null,
            timeStart: Moment(),
            timeEnd: Moment(),
            datesInvalid: false
          });
        }
      }

      // Reset form to defaults after a successful create (only for new records)
      if (prevProps.submitResult !== this.props.submitResult) {
        var res = this.props.submitResult;
        if (res && res.success === true && this.props.absence == null) {
          // Reset redux-form fields
          if (this.props.reset) this.props.reset();
          if (this.props.change) this.props.change(FORM_NAME, 'entireDay', 'yes');
          // Reset local state to defaults
          this.setState({
            id: null,
            timeStart: Moment(),
            timeEnd: Moment(),
            datesInvalid: false
          });
          // Show success briefly, then clear submit result in store
          var successMsg = this.props.translate('Absence record saved successfully');
          this.setState({
            successMessage: successMsg,
            showSuccess: true
          });
          if (this._clearSuccessTimeout) clearTimeout(this._clearSuccessTimeout);
          this._clearSuccessTimeout = setTimeout(function () {
            if (_this2.props.clearSubmitResult) _this2.props.clearSubmitResult();
            _this2.setState({
              showSuccess: false,
              successMessage: ''
            });
            _this2._clearSuccessTimeout = null;
          }, 3000);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._clearSuccessTimeout) {
        clearTimeout(this._clearSuccessTimeout);
        this._clearSuccessTimeout = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var datesInvalid = this.state.datesInvalid;
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        translate = _this$props.translate,
        absence = _this$props.absence,
        isDirectRender = _this$props.isDirectRender,
        entireDay = _this$props.entireDay,
        submitResult = _this$props.submitResult,
        showCancelButton = _this$props.showCancelButton,
        onCancel = _this$props.onCancel;
      var isLoading = submitting || this.state.deleting;
      var disableEditing = false;
      if (absence != null) {
        disableEditing = Moment.utc(absence.startTime).local().unix() < Moment().unix() && Moment().diff(Moment.utc(absence.reported).local(), 'minutes') > 15;
      }
      var formContent = /*#__PURE__*/React.createElement(React.Fragment, null, isLoading && /*#__PURE__*/React.createElement(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          py: 3
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), /*#__PURE__*/React.createElement(Box, {
        sx: {
          display: isLoading ? 'none' : 'block'
        }
      }, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(FormControl, {
        fullWidth: true,
        sx: {
          mb: 0
        }
      }, /*#__PURE__*/React.createElement(Stack, {
        direction: "column",
        spacing: 1
      }, /*#__PURE__*/React.createElement(Field, {
        name: "entireDay",
        component: this.renderEntireDayRadio,
        disabled: disableEditing
      }))), /*#__PURE__*/React.createElement(Divider, {
        sx: {
          my: 3
        }
      }), /*#__PURE__*/React.createElement(Stack, {
        direction: {
          xs: 'column',
          sm: 'row'
        },
        spacing: 3,
        sx: {
          mb: 3
        }
      }, /*#__PURE__*/React.createElement(Stack, {
        direction: "row",
        spacing: 1.5,
        sx: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(Box, {
        sx: {
          flex: 1,
          minWidth: 0
        }
      }, /*#__PURE__*/React.createElement(DatePicker, {
        label: translate('Start'),
        value: Moment(this.state.timeStart),
        onChange: function onChange(d) {
          return _this3.onTimeChange({
            start: d,
            end: Moment(_this3.state.timeEnd)
          });
        },
        minDate: Moment(),
        inputFormat: function inputFormat() {
          return 'YYYY-MM-DD';
        },
        disabled: disableEditing,
        fullWidth: true
      })), this.props.entireDay == 'no' && /*#__PURE__*/React.createElement(Box, {
        sx: {
          width: 130,
          flexShrink: 0
        }
      }, /*#__PURE__*/React.createElement(TimePicker, {
        label: translate('Time'),
        value: Moment(this.state.timeStart),
        onChange: function onChange(t) {
          return _this3.onTimeChange({
            start: t,
            end: Moment(_this3.state.timeEnd)
          });
        },
        disabled: disableEditing,
        fullWidth: true
      }))), /*#__PURE__*/React.createElement(Stack, {
        direction: "row",
        spacing: 1.5,
        sx: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(Box, {
        sx: {
          flex: 1,
          minWidth: 0
        }
      }, /*#__PURE__*/React.createElement(DatePicker, {
        label: translate('End'),
        value: Moment(this.state.timeEnd),
        onChange: function onChange(d) {
          return _this3.onTimeChange({
            start: Moment(_this3.state.timeStart),
            end: d
          });
        },
        minDate: Moment(this.state.timeStart),
        inputFormat: function inputFormat() {
          return 'YYYY-MM-DD';
        },
        disabled: disableEditing,
        fullWidth: true
      })), this.props.entireDay == 'no' && /*#__PURE__*/React.createElement(Box, {
        sx: {
          width: 130,
          flexShrink: 0
        }
      }, /*#__PURE__*/React.createElement(TimePicker, {
        label: translate('Time'),
        value: Moment(this.state.timeEnd),
        onChange: function onChange(t) {
          return _this3.onTimeChange({
            start: Moment(_this3.state.timeStart),
            end: t
          });
        },
        disabled: disableEditing,
        fullWidth: true
      })))), datesInvalid && /*#__PURE__*/React.createElement(Alert, {
        severity: "error",
        sx: {
          mb: 2
        }
      }, translate('Invalid date or time range')), submitResult && submitResult.success === false && /*#__PURE__*/React.createElement(Alert, {
        severity: "error",
        sx: {
          mb: 2
        }
      }, translate(submitResult.errorMessage)), submitResult && submitResult.success === true && /*#__PURE__*/React.createElement(Alert, {
        severity: "success",
        sx: {
          mb: 2
        }
      }, translate('Absence record saved successfully')), /*#__PURE__*/React.createElement(Divider, {
        sx: {
          my: 3
        }
      }), /*#__PURE__*/React.createElement(Stack, {
        direction: {
          xs: 'column-reverse',
          sm: 'row'
        },
        spacing: {
          xs: 1.5,
          sm: 2
        },
        sx: {
          mt: 2
        },
        justifyContent: "space-between",
        alignItems: {
          xs: 'stretch',
          sm: 'center'
        }
      }, /*#__PURE__*/React.createElement(Stack, {
        direction: {
          xs: 'column',
          sm: 'row'
        },
        spacing: {
          xs: 1.5,
          sm: 1
        },
        sx: {
          flex: 1
        }
      }, showCancelButton && onCancel ? /*#__PURE__*/React.createElement(Button, {
        onClick: onCancel,
        disabled: submitting,
        type: "secondary"
      }, translate('Cancel')) : null, this.props.absence && /*#__PURE__*/React.createElement(Button, {
        onClick: this.onDelete,
        disabled: submitting || disableEditing || this.state.deleting,
        type: "secondary",
        sx: {
          color: 'error.main'
        }
      }, translate('Remove'))), /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        variant: "contained",
        disabled: submitting || !entireDay || disableEditing || datesInvalid,
        sx: {
          minWidth: {
            sm: 180
          }
        }
      }, this.state.id != null ? translate('Save') : translate('Report absence'))))));

      // Direct render mode: return form in card container
      if (isDirectRender) {
        return /*#__PURE__*/React.createElement(Container, {
          maxWidth: false,
          disableGutters: true,
          sx: {
            py: 2,
            px: 0
          }
        }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardContent, {
          sx: {
            p: {
              xs: 2,
              sm: 3
            }
          }
        }, formContent)));
      }

      // Modal mode: wrap in div for backward compatibility
      return /*#__PURE__*/React.createElement("div", null, formContent);
    }
  }]);
}(Component);
var FORM_NAME = 'ReportAbsence';
var getFormValue = formValueSelector(FORM_NAME);
function mapStateToProps(state) {
  return {
    submitResult: state.absence.submitResult,
    absences: state.absence.user,
    translate: translate(state.Languages.translations),
    entireDay: getFormValue(state, 'entireDay')
  };
}
function mapDispatchToProps(dispatch) {
  return {
    deleteAbsence: function deleteAbsence(id) {
      return dispatch(_deleteAbsence(id));
    },
    clearSubmitResult: function clearSubmitResult() {
      return dispatch(_clearSubmitResult());
    },
    addError: function addError(error) {
      return dispatch(_addError(error));
    },
    change: function change(form, field, value) {
      return dispatch(_change(form, field, value));
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  initialValues: {
    entireDay: 'yes'
  }
})(ReportAbsenceForm));